import { render, staticRenderFns } from "./ChecktestQuestionMessage.vue?vue&type=template&id=c69e7a48&"
import script from "./ChecktestQuestionMessage.vue?vue&type=script&lang=ts&"
export * from "./ChecktestQuestionMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports